import React from 'react';
import Styled from 'styled';
import SVGImageView from './svg-image-view';
import defaultStyles from './svg-icon-view.scss';

export default Styled(defaultStyles)(props => <SVGImageView {...props} />);
